var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-check-data" },
    [
      _c(
        "v-expansion-panels",
        {
          attrs: { accordion: "", tile: "", multiple: "" },
          model: {
            value: _vm.panel,
            callback: function($$v) {
              _vm.panel = $$v
            },
            expression: "panel"
          }
        },
        [
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _vm._v("Angaben zur Antragstellerin bzw. dem Antragsteller")
              ]),
              _c(
                "v-expansion-panel-content",
                { attrs: { eager: "" } },
                [
                  _c("applicant-information", {
                    ref: "applicant-info",
                    attrs: { readonly: "" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [_vm._v("Bankverbindung")]),
              _c(
                "v-expansion-panel-content",
                { attrs: { eager: "" } },
                [
                  _c("bank-details", {
                    ref: "bank-details",
                    attrs: { readonly: "" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _vm._v("Angaben zur Förderberechtigung")
              ]),
              _c(
                "v-expansion-panel-content",
                { attrs: { eager: "" } },
                [
                  _c("funding-information", {
                    ref: "funding-info",
                    attrs: { readonly: "" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _vm._v("Künstlerisches Konzept")
              ]),
              _c(
                "v-expansion-panel-content",
                { attrs: { eager: "" } },
                [
                  _c("artistic-concept", {
                    ref: "artistic-concept",
                    attrs: { readonly: "" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt-8 text-center" },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "primary", outlined: "" },
              on: {
                click: function($event) {
                  _vm.showPrintDialog = true
                }
              }
            },
            [_vm._v("Antragsdaten drucken")]
          )
        ],
        1
      ),
      _c(
        "v-form",
        {
          ref: "check-form",
          staticClass: "mt-8",
          attrs: { "lazy-validation": "" }
        },
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c("p", { staticClass: "hint-label font-weight-bold mb-1" }, [
                  _vm._v("Abschließende Erklärung")
                ]),
                _c("p", { staticClass: "hint-label mb-0" }, [
                  _vm._v(
                    "Die hier getätigten Angaben sowie die Angaben in den beigefügten Anlagen sind vollständig und entsprechen der Wahrheit. Die Fördermittel werden nur zur Erfüllung des in diesem Antrag bestimmten Zweckes verwendet. Alle relevanten Änderungen der beantragten Maßnahme und insbesondere seiner Finanzierung werde ich unverzüglich schriftlich der GVL mitteilen *"
                  )
                ]),
                _c("p", { staticClass: "hint-label mb-0" }, [
                  _vm._v(
                    "Die Fördermittel werden nur zur Erfüllung des in diesem Antrag bestimmten Zweckes verwendet. Alle relevanten Änderungen müssen unverzüglich der GVL mittgeteilt werden. Mit dem Vorhaben wurde noch nicht begonnen."
                  )
                ]),
                _c("p", { staticClass: "hint-label mb-0" }, [
                  _vm._v(
                    "Die beantragten Maßnahmen können nicht ohne BKM-Mittel finanziert werden, auch nicht durch Übernahme einer Bürgschaft, Garantie oder sonstigen Gewährleistung sowie der Gewährung einer rückzahlbaren Zuwendung."
                  )
                ]),
                _c("p", { staticClass: "hint-label mb-0" }, [
                  _vm._v(
                    "Mir sind die Tatsachen nach Nr. 3.4.1. bis 3.4.3 der VV zu § 44 Bundeshaushaltsordnung (Link zu BHO) als subventionserheblich und die Strafbarkeit eines Subventionsbetruges nach § 264 Strafgesetzbuch (Link zu StGB) bekannt."
                  )
                ])
              ]),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-checkbox", {
                    attrs: {
                      label:
                        "Hiermit bestätige ich meine Angaben und versichere, dass ich die Antragsvoraussetzungen zur Kenntnis genommen und alle Angaben nach bestem Wissen und Gewissen sowie wahrheitsgetreu getätigt habe.",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue(
                          "bestaetigung_angaben_korrekt",
                          v
                        )
                      }
                    },
                    model: {
                      value: _vm.formData.bestaetigung_angaben_korrekt,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formData,
                          "bestaetigung_angaben_korrekt",
                          $$v
                        )
                      },
                      expression: "formData.bestaetigung_angaben_korrekt"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c("v-checkbox", {
                    attrs: {
                      label:
                        "Ich erkläre, dass ich die Finanzbehörden von der Verpflichtung zur Wahrung des Steuergeheimnisses gegenüber den Bewilligungsstellen und den Strafverfolgungsbehörden befreie, soweit es sich um Angaben / Daten handelt, die für die Gewährung der Förderung / des Stipendiums von Bedeutung sind. Dementsprechend nehme ich auch zur Kenntnis, dass die Bewilligungsstellen von den Finanzbehörden Auskünfte über den/die Antragssteller/in einholen dürfen, soweit diese für die Bewilligung, Gewährung, Rückforderung, Erstattung oder Belassen der Hilfe erforderlich sind.",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue(
                          "bestaetigung_finazbehoerden",
                          v
                        )
                      }
                    },
                    model: {
                      value: _vm.formData.bestaetigung_finazbehoerden,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formData,
                          "bestaetigung_finazbehoerden",
                          $$v
                        )
                      },
                      expression: "formData.bestaetigung_finazbehoerden"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c("v-checkbox", {
                    attrs: {
                      label:
                        "Ich habe zur Kenntnis genommen, dass kein Rechtsanspruch auf die Förderung bzw. das Stipendium besteht und dass die Förderung bzw. das Stipendium in der Einkommensteuer-/Gewerbesteuererklärung zu erfassen sind. Zudem bestätige ich, dass Steuern und Sozialabgaben ordnungsgemäß abgeführt werden.",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue(
                          "bestaetigung_rechtsanspruch",
                          v
                        )
                      }
                    },
                    model: {
                      value: _vm.formData.bestaetigung_rechtsanspruch,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formData,
                          "bestaetigung_rechtsanspruch",
                          $$v
                        )
                      },
                      expression: "formData.bestaetigung_rechtsanspruch"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c("v-checkbox", {
                    attrs: {
                      label:
                        "Ich bin damit einverstanden, dass im Rahmen einer bereits bestehenden Geschäftsbeziehung zur GVL für die Antragsbearbeitung die gespeicherten Stammdaten wie Name, Anschrift, E-Mail, GVL-ID, KSK-Nummer, Bankverbindung verwendet werden.",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue(
                          "bestaetigung_stammdaten_verwenden",
                          v
                        )
                      }
                    },
                    model: {
                      value: _vm.formData.bestaetigung_stammdaten_verwenden,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formData,
                          "bestaetigung_stammdaten_verwenden",
                          $$v
                        )
                      },
                      expression: "formData.bestaetigung_stammdaten_verwenden"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c("v-checkbox", {
                    attrs: {
                      label:
                        "Ich bin damit einverstanden, dass die Zustellung von Dokumenten wie Verträgen und Bescheiden ausschließlich digital über die von mir angegebene E-Mail-Adresse erfolgt.",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue(
                          "bestaetigung_zustellung_dokumente",
                          v
                        )
                      }
                    },
                    model: {
                      value: _vm.formData.bestaetigung_zustellung_dokumente,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formData,
                          "bestaetigung_zustellung_dokumente",
                          $$v
                        )
                      },
                      expression: "formData.bestaetigung_zustellung_dokumente"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c(
                    "v-checkbox",
                    {
                      attrs: { dense: "", rules: [_vm.rules.required] },
                      on: {
                        input: function(v) {
                          return _vm.saveFieldValue(
                            "bestaetigung_datenschutz",
                            v
                          )
                        }
                      },
                      model: {
                        value: _vm.formData.bestaetigung_datenschutz,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formData,
                            "bestaetigung_datenschutz",
                            $$v
                          )
                        },
                        expression: "formData.bestaetigung_datenschutz"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "custom-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _c("span", [_vm._v("Hiermit bestätige ich die")]),
                          _c(
                            "a",
                            {
                              staticClass: "ml-2",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  _vm.showInfoModal = true
                                }
                              }
                            },
                            [_vm._v("Datenschutzerklärung")]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c("v-checkbox", {
                    attrs: {
                      label:
                        "Hiermit bestätige ich, dass mir die Tatsachen nach Nr. 3.4.1. bis 3.4.3 der VV zu § 44 Bundeshaushaltsordnung (BHO) als subventionserheblich und die Strafbarkeit eines Subventionsbetruges nach § 264 Strafgesetzbuch (StGB) bekannt sind.",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue(
                          "bestaetigung_bundeshaushaltsordnung",
                          v
                        )
                      }
                    },
                    model: {
                      value: _vm.formData.bestaetigung_bundeshaushaltsordnung,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formData,
                          "bestaetigung_bundeshaushaltsordnung",
                          $$v
                        )
                      },
                      expression: "formData.bestaetigung_bundeshaushaltsordnung"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-3",
                      attrs: { color: "primary", block: "" },
                      on: { click: _vm.onSubmit }
                    },
                    [_vm._v("Antrag absenden")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "overlay-spinner" },
            [
              _c("v-progress-circular", {
                attrs: { size: 60, color: "#ccc", indeterminate: "" }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { width: "600px" },
          model: {
            value: _vm.showInfoModal,
            callback: function($$v) {
              _vm.showInfoModal = $$v
            },
            expression: "showInfoModal"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title"),
              _c("v-card-text", [
                _vm._v(
                  "Ihre hier erhobenen personenbezogenen Daten (Namen, Funktionen im Unternehmen, Gesellschafterverhältnisse, Erreichbarkeiten, Anschriften, Auszahlungsdaten) nutzen wir, die Gesellschaft zur Verwertung von Leistungsschutzrechten mbH (GVL), zur Prüfung der Voraussetzungen für eine Zuerkennung einer Bundesförderung aus dem Programm „Neustart Kultur“ der Beauftragten der Bundesregierung für Kultur und Medien (BKM) sowie im Falle einer positiven Entscheidung zur Abwicklung des abzuschließenden Vertrages über die Weiterleitung von Zuwendungen."
                ),
                _c("br"),
                _vm._v(
                  "\nIm Falle des Abschlusses eines Vertrages mit Ihnen übermitteln wir Ihre Daten an die Beauftragte der Bundesregierung für Kultur und Medien (BKM), Graurheindorfer Straße 198, 53117 Bonn. Zweck der Übermittlung an die BKM ist, der BKM und ggf. dem Bundesrechnungshof die Prüfung der Einhaltung öffentlich-rechtlicher Vorschriften im Rahmen der Bewilligung von Zuwendungen zu ermöglichen."
                ),
                _c("br"),
                _vm._v(
                  "\nRechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 Satz 1 Buchst. b DSGVO bzw. im Falle der Datenverarbeitung durch die BKM und den Bundesrechnungshof auch Art. 6 Abs. 1 Satz 1 Buchst. c DSGVO."
                ),
                _c("br"),
                _vm._v(
                  "\nIch bestätige, dass ich der Bewilligungsstelle und sonstigen zuständigen Behörden auf Verlangen die zur Aufklärung des Sachverhalts und Bearbeitung eines Antrags ‚erforderlichen Unterlagen und Informationen unverzüglich zur Verfügung stelle."
                ),
                _c("br"),
                _vm._v(
                  "\nFür den Fall, dass ein Vertrag über die Weiterleitung von Zuwendungen mit Ihnen nicht zustande kommt, löschen wir Ihre Daten, die zu o.g. Zweck erhoben und gespeichert wurden, sechs Monate oder, wenn das Programm länger als sechs Monate laufen sollte, bis zum Programmabschluss nach unserer ablehnenden Mitteilung an Sie. Sofern ein Vertrag über die Weiterleitung von Zuwendungen mit Ihnen abgeschlossen wird, speichern wir Ihre personenbezogenen Daten, soweit wir gesetzlich dazu verpflichtet sind. Solche Nachweis- und Aufbewahrungspflichten ergeben sich unter anderem aus dem Handelsgesetzbuch, der Bundeshaushaltsordnung oder steuerrechtlichen Vorschriften und sehen Fristen von bis zu zehn Jahren vor. Rechtsgrundlage hierfür ist Art. 6 Abs. 1 Satz 1 Buchst. c DSGVO."
                )
              ]),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", block: "", outlined: "" },
                      on: {
                        click: function($event) {
                          _vm.showInfoModal = false
                        }
                      }
                    },
                    [_vm._v("Schließen")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "1200px" },
          model: {
            value: _vm.showPrintDialog,
            callback: function($$v) {
              _vm.showPrintDialog = $$v
            },
            expression: "showPrintDialog"
          }
        },
        [
          _c("print-data", {
            on: {
              close: function($event) {
                _vm.showPrintDialog = false
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }